module.exports = __webpack_public_path__ + "img/4_61.bcf13663.png";